<mat-form-field floatLabel="always" class="w-full" [appearance]="appearance || 'legacy'">
  <mat-label *ngIf="!noLabel">{{ placeholder }}</mat-label>
  <fb-anex *ngIf="prefix && prefix.type !== 'text'" matPrefix [config]="prefix" position="start"></fb-anex>
  <input
    matInput
    fbDisableAutocomplete
    [mask]="mask || '(000) 000-0000'"
    [validation]="true"
    [prefix]="phonePrefix ? '+' + phonePrefix + ' ' : '+'"
    [formControl]="phoneControl"
    [placeholder]="placeholder"
    [required]="required"
    [fbDisableControl]="disable"
    [readonly]="readonly"
    (focusout)="onTouched()"
  />
  <ng-container *ngIf="(loading.active$ | async) === false; else showLoader">
    <ng-container *ngIf="suffix; else showButtons">
      <fb-anex
        matSuffix
        [config]="suffix"
        [control]="ngControl.control"
        [templates]="templates"
        position="end"
      ></fb-anex>
    </ng-container>
    <ng-template #showButtons>
      <button
        *ngIf="phoneControl.value"
        tabindex="-1"
        type="button"
        mat-icon-button
        matSuffix
        (click)="onClear(); onTouched(); $event.stopPropagation(); $event.preventDefault()"
        [disabled]="disable || readonly"
      >
        <mat-icon [inline]="true" class="icon-button">clear</mat-icon>
      </button>
    </ng-template>
  </ng-container>
  <ng-template #showLoader>
    <fb-loader class="position-relative loader" [message]="undefined" [size]="20" matSuffix></fb-loader>
  </ng-template>
</mat-form-field>
